import {AfterViewInit, Component,  OnDestroy, Input, OnInit} from '@angular/core';
import {PlaylistsService}  from "../../services/playlists.service";

import { ClipboardService } from 'ngx-clipboard'
import { NbGlobalPosition, NbDialogService, NbToastrService, NbComponentStatus } from '@nebular/theme';
 import {AuthService}  from "../../services/auth.service";
 
@Component({
  selector: 'app-playlist-sale-control',
  templateUrl: './playlist-sale-control.component.html',
  styleUrls: ['./playlist-sale-control.component.scss'],
})
export class PlaylistSaleControlComponent implements OnInit, OnDestroy{


   
  @Input() playlist: any
  price: number = 0
 subscribeSetSale$:any = null
subscribeSetPrice$:any = null
loading:boolean = false
saleOn:boolean = false


   constructor(
    public playlistsService: PlaylistsService,
    private _clipboardService: ClipboardService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    public authService : AuthService

    ){
  }
 

  
 priceChange(){

	if(this.price === this.playlist.price){return}
	if(this.price <1){
		
      this.toastrService.show('','Некоректна ціна',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })

		this.price = this.playlist.price
		return
	}



		this.setPrice(this.price)
 
	
 }
 

 toggleSaleOn(){
	if(this.saleOn){
          this.setSale(true)
	}else{
          this.setSale(false)
	}
 }


  setSale(sale){
    
    this.loading = true

	if( this.subscribeSetSale$){
      this.subscribeSetSale$.unsubscribe()
     }
    this.subscribeSetSale$ = this.playlistsService.updateSaleMode(this.playlist._id, sale).subscribe((playlist)=>{
  
 
            this.playlist.saleMode = playlist.saleMode
		this.saleOn = playlist.saleMode
      this.loading = false
    },(error)=>{
      this.loading = false

      // The stored state wins and the server's reason is shown - see the stream
      // sale control.
      this.saleOn = this.playlist.saleMode === true

      this.toastrService.show('',(error && error.error && error.error.message) || 'Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
  }


	setPrice(price){
	    
		 if(this.authService.priceLimit && price !==  this.authService.priceLimit){

		this.showToast(`Не можна змінювати ціну в безкоштовному тарифі`, 'danger')
		return false
		}


	    this.loading = true

		if( this.subscribeSetPrice$){
	      this.subscribeSetPrice$.unsubscribe()
	     }

	    this.subscribeSetPrice$ = this.playlistsService.updatePrice(this.playlist._id, price).subscribe((playlist)=>{
	  
	      this.playlist.price = playlist.price 
	     this.price = playlist.price 

	 	 this.toastrService.show('','Ціна збережена',{
			status: 'success',
			icon:'',
			position: <NbGlobalPosition>'bottom-right'
			  })

	      this.loading = false

	    },(error)=>{
	      this.loading = false
	  
	      this.toastrService.show('','Сталася помилка сервера',{
		status: 'danger',
		icon:'',
		position: <NbGlobalPosition>'bottom-right'
		  })
	    })


	  }


 showToast(text, status = 'primary'){

  this.toastrService.show('',text,{
    status: <NbComponentStatus>status,
    icon: '',
    position: <NbGlobalPosition>'bottom-end'
      })
 } 

  ngOnInit() {

	this.price = this.playlist.price
		this.saleOn = this.playlist.saleMode

  }


   ngOnDestroy() {
    if( this.subscribeSetSale$){
      this.subscribeSetSale$.unsubscribe()
     }
    if( this.subscribeSetPrice$){
	      this.subscribeSetPrice$.unsubscribe()
    }
   }
 

 

  
}
